import { render, staticRenderFns } from "./workflowDetail.vue?vue&type=template&id=39b16b4f&scoped=true&"
import script from "./workflowDetail.vue?vue&type=script&lang=js&"
export * from "./workflowDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b16b4f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39b16b4f')) {
      api.createRecord('39b16b4f', component.options)
    } else {
      api.reload('39b16b4f', component.options)
    }
    module.hot.accept("./workflowDetail.vue?vue&type=template&id=39b16b4f&scoped=true&", function () {
      api.rerender('39b16b4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/workflow/workflow/workflowDetail.vue"
export default component.exports